import { render, staticRenderFns } from "./ExportReturns.vue?vue&type=template&id=bce9fbda&scoped=true&"
import script from "./ExportReturns.vue?vue&type=script&lang=js&"
export * from "./ExportReturns.vue?vue&type=script&lang=js&"
import style0 from "./ExportReturns.vue?vue&type=style&index=0&id=bce9fbda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bce9fbda",
  null
  
)

export default component.exports